import Button from "devextreme-react/button";
import * as React from "react";
import { useEffect, useState } from "react";

const ShowHider = ({ targetref, defaultValue }) => {
    const [needShowReportFilterContainer, setNeedShowReportFilterContainer] = useState(true);
    const [hint, setHint] = useState("");
    const [icon, setIcon] = useState("");
    const showHideReportFilterContainer = (value) => {
        setNeedShowReportFilterContainer(value);
        setHint(value ? "Скрыть" : "Показать");
        setIcon(value ? "hidepanel" : "showpanel");
        const obj = targetref && targetref.current;
        if (!obj) {
            return;
        }
        if (value) {
            obj.classList.remove('hided-object');
        }
        else {
            obj.classList.add('hided-object');
        }
    }

    const showHideClick = (e) => {
        showHideReportFilterContainer(!needShowReportFilterContainer);
    }

    useEffect(
        () => {
            showHideReportFilterContainer(defaultValue);
        }
        ,
        []
    );

    return (
        <Button
            className="button-show-hide-report-filter-container"
            icon={icon}
            hint={hint}
            onClick={showHideClick}
        />
    )

}
export default ShowHider;
